import {
  AppContext,
  BackgroundIcon,
  Icon,
  isAuthorised,
  ALL_MODULES,
  getDownloadURL,
  EventEmitter,
  UserAppMenu,
  AccessControl,
  UserAppMenuNew,
  MenuPage,
  getTranslatedText,
  GlobalTimerSection,
  CLIENT_PORTAL_IT_DOC_DEFAULT_ENTITY_NAME,
  useActivityTracker,
  Notifications,
  useInAppNotificationsCount,
  COMMON_CONSTANTS,
  useCheckFeatureGating
} from '@nile/components';
import envConfig from '@nile/home/src/Config/env';
import { SVGIcon } from '@superops/super-icons';
import { injectIntl, FormattedMessage } from 'react-intl';
import { LogOutCircle } from '@styled-icons/boxicons-regular';
import React, {
  Component,
  forwardRef,
  useCallback,
  useContext,
  useState
} from 'react';
import { withRouter } from 'react-router-dom';
import Tippy from '@tippyjs/react';
import styled from 'styled-components';
import { HomeContext } from '@nile/mangifera/src/Contexts';
import { cloneDeep, head } from 'lodash';
import { withLDConsumer, useFlags } from 'launchdarkly-react-client-sdk';
import { hotjarTracking } from '@nile/client_management/src/Constants/Client';
import { Tooltip } from 'react-clone-tippy';
import dompurify from 'dompurify';
import SchedulingNavigationWidget from '@nile/components/src/Components/SchedulingNavigationWidget';
import { dompurifier } from '@nile/components/src/Utils/helpers';
import { Card, TextStyle } from '@superops/ui-design-system';

const UpdatesCountWrapper = styled.div`
  width: 16px;
  height: 16px;
  border-radius: 2px;
  background: #ff0055;
  position: absolute;
  top: 5px;
  right: 7px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  font-weight: 500;
`;
function UpdatesCountBubble({ count }) {
  return <UpdatesCountWrapper>{count}</UpdatesCountWrapper>;
}

function NavItemWithTippy({
  item,
  renderIcon,
  tippyProps,
  children,
  bubbleCount
}) {
  const homeContext = useContext(HomeContext);
  const appContext = useContext(AppContext);
  const [IsContentVisible, setIsContentVisible] = useState(false);

  const handleShow = useCallback(() => {
    setIsContentVisible(true);
    tippyProps.onShow?.();
  }, [tippyProps]);

  const handleHide = useCallback(() => {
    setIsContentVisible(false);
    tippyProps.onHide?.();
  }, [tippyProps]);

  return (
    <Tippy
      delay={100}
      placement="left"
      arrow={false}
      interactive
      trigger="mouseenter"
      theme="light"
      allowHTML
      appendTo={document.body}
      offset={[0, 5]}
      maxWidth={600}
      minWidth={300}
      className="app-menu-tippy"
      {...tippyProps}
      onShow={handleShow}
      onHide={handleHide}
      content={IsContentVisible && children}
    >
      <Section
        id={`${item.name}SideNavbar`}
        selected={item.name === homeContext.selectedModule}
      >
        <div
          id={item.id}
          className={`${
            item.customLogo ? '' : 'ptr'
          } appIcon flex flex-center full-width`}
          url={item.url}
        >
          <Tooltip
            title={dompurifier(item.label)}
            position="right"
            interactive
            delay={200}
            trigger="mouseenter click"
            animation="shift"
            animateFill={false}
            className="full-width"
          >
            <SectionHolder className="full-width">
              <div>{renderIcon(item, appContext)}</div>
            </SectionHolder>
          </Tooltip>
        </div>
        {bubbleCount > 0 && (
          <UpdatesCountBubble count={bubbleCount > 99 ? '99+' : bubbleCount} />
        )}
      </Section>
    </Tippy>
  );
}

const BottomSection = styled.div`
  position: absolute;
  bottom: 70px;
  left: 0;
`;
const AppNavStyle = styled.div`
  width: 100% !important;
  #logoSideNavbar {
    margin-bottom: 10px;
    margin-top: 5px;
  }
  .Polaris-Icon {
    filter: contrast(0);
  }
  .Polaris-ResourceItem__Media {
    font-size: 20px;
  }
  .Polaris-ResourceItem__Container {
    padding: 0.8rem 1.2rem !important;
  }
  .Polaris-Link {
    display: flex;
    justify-content: center;
    padding: 14px;
    flex-grow: 1;
  }
  .bottom {
    position: absolute;
    bottom: 0px;
    padding: 8px 0px;
  }
  .appIcon {
    width: 100%;
    height: 50px;
  }
  .company-multiple {
    position: relative;
    .more-icon {
      position: absolute;
      top: 16px;
      right: 0;
    }
  }
`;
const AssosiationPopover = styled.div`
  min-width: 220px !important;
  background: #fff;
  border-radius: 10px;
  min-height: 60px;
  padding: 20px 4px 20px 10px;
  .assosiation-item {
    font-size: 14px;
    line-height: 21px;
    padding: 10px 0 10px 8px;
    cursor: pointer;
    &:hover {
      background: #e3edff;
    }
  }
`;
const Section = styled.div`
  display: flex;
  border-radius: 5px;
  position: relative;
`;
const SectionHolder = styled.div`
  display: flex;
  color: #fff;
  align-items: center;
  flex-direction: column;
  font-size: 10px;
  text-transform: uppercase;
`;
const Logo = styled.div`
  img {
    max-height: 40px;
    max-width: 40px;
  }
`;
const Wrapper = styled.div`
  padding: 10px 0px 15px;
  min-width: 300px !important;
  background: var(--sops-module-bg);
  border-radius: 10px;
  .subject {
    color: #0000ff;
  }
`;

const path = '/';

class AppNavigation extends Component {
  static contextType = HomeContext;

  constructor(props) {
    super(props);
    this.state = {
      activePage: this.getPathName(),
      selectedSection: null,
      appLogo: null,
      assosiationPopoverActive: false,
      openMenuItem: false
    };
  }

  handleLogoChange = (appLogo) => {
    this.setState({ appLogo });
  };

  componentDidMount() {
    const appContext = this.context;
    const allSections = ['ticket', 'settings', 'home', 'search'];
    const pathName = this.props?.history?.location?.pathname;
    let section = pathName?.split('/')[1];
    if (allSections.indexOf(section) === -1) section = null;
    this.setState({ activePage: this.getPathName(), selectedSection: section });
    this.context.updateSelectedModule(section);
    EventEmitter.subscribe('logoChange', this.handleLogoChange);
  }

  componentWillUnmount() {
    EventEmitter.unsubscribe('logoChange', this.handleLogoChange);
  }

  getPathName(path) {
    const pathname = path || this.props?.history?.location?.pathname;
    if (!pathname) return '';
    const segments = pathname.split('/');
    return segments[segments.length - 1];
  }

  /**
   * OnClick on app side bar, setting active tab and performing app update for settings click
   *
   * @param {object} item
   * @param {object} homeContext
   */
  handleClick = (item, homeContext, appContext) => {
    const {
      userAppState,
      updateUserAppState,
      closeCreateNewOverlay,
      closeModulesOverlay,
      closeSettingsOverlay,
      switchTabFocus,
      closeHomeOverlay,
      toggleHomeOverlay,
      toggleModulesOverlay,
      toggleCreateNewOverlay,
      toggleSettingsOverlay,
      toggleSpotlightOverlay,
      selectedModule
    } = homeContext;
    const { user, accountType } = appContext;
    const currentAppState = userAppState || { appState: [] };
    const updatedAppState = cloneDeep(currentAppState.appState);

    this.setState({ selectedSection: item.name });
    item.id !== 156 && homeContext.updateSelectedModule(item.name);

    if (accountType === 'CLIENT') {
      if (item.name === 'ticket' || item.label === 'Create') {
        let tab = updatedAppState.find((el) => el.id === item?.tabData?.id);
        if (!tab) {
          tab = item.tabData;
          updatedAppState.push(item.tabData);
        }
        updateUserAppState(
          {
            ...currentAppState,
            appState: updatedAppState,
            activeTabIndex: updatedAppState.findIndex((el) => el.id === tab.id)
          },
          () => {
            switchTabFocus(tab);
          }
        );
      } else {
        if (item.url) this.props.history.push(item.url);
      }
    } else if (
      item.url ||
      item.name === 'home' ||
      item.name === 'productonboard'
    ) {
      this.setState({ activePage: this.getPathName(item.url) });
      if (
        (accountType !== 'CLIENT' && item.name === 'home') ||
        item.name === 'productonboard'
      ) {
        let tab;
        if (item.name === 'home') {
          tab = updatedAppState.find((el) => el.id === 'home-tab');
          if (!tab) {
            tab = {
              id: 'home-tab',
              content: '',
              module: 'HOME',
              tabId: 'home-tab',
              state: {},
              data: {},
              url: '/home'
            };
            updatedAppState.push(tab);
          }
        }
        updateUserAppState({
          ...currentAppState,
          appState: updatedAppState,
          activeTabIndex: updatedAppState.findIndex((el) => el.id === tab.id)
        });
        closeCreateNewOverlay();
        closeModulesOverlay();
        closeSettingsOverlay();
        closeHomeOverlay();
        setTimeout(() => {
          switchTabFocus(tab);
        }, 200);
      }
    } else if (item.name === 'create') toggleCreateNewOverlay();
    else if (item.name === 'modules') toggleModulesOverlay();
    else if (item.name === 'settings') toggleSettingsOverlay();
    else if (item.name === 'home') toggleHomeOverlay();
    else if (item.name === 'search') toggleSpotlightOverlay();
  };

  render() {
    const { conf, intl, flags, KbClientNavCheck } = this.props;
    const { activePage, selectedSection } = this.state;

    const marketplaceMenus = [
      {
        id: 'MARKETPLACE_DISCOVER_APPS',
        icon: 'ExploreMore',
        route: '/agent/marketplace',
        messageId: 'agentMarketplace.navbar.discoverApps'
      },
      {
        id: 'MARKETPLACE_MY_ORG_AGENTS',
        icon: 'Integration',
        route: '/agent/marketplace/my-org-agents',
        messageId: 'agentMarketplace.navbar.myOrgAgents'
      }
    ];

    const technicianModules = [
      {
        id: 157,
        url: null,
        name: 'home',
        label: getTranslatedText(intl, 'app.nav.home'),
        location: '',
        data: {
          isClientPortal: true
        },
        icon: (
          <div className="fx center">
            <SVGIcon name="HomePlain" color="var(--sops-app-nav-text-color)" />
          </div>
        )
      },
      {
        id: 'UPDATES',
        url: null,
        name: 'updates',
        label: getTranslatedText(intl, 'common.updates'),
        location: '',
        icon: (
          <div className="fx center">
            <SVGIcon
              name="NotificationsBell"
              color="var(--sops-app-nav-text-color)"
            />
          </div>
        )
      },
      {
        id: 'APP_MSP_NAV_SEARCH',
        url: null,
        name: 'search',
        label: getTranslatedText(intl, 'app.filter.search.label'),
        location: '',
        icon: (
          <div className="fx center">
            <SVGIcon
              name="SearchNew"
              color="var(--sops-app-nav-text-color)"
              size="lg"
            />
          </div>
        )
      },
      {
        id: 'APP_MSP_NAV_MODULES',
        url: null,
        name: 'modules',
        location: '',
        icon: (
          <div className="fx center">
            <SVGIcon name="Modules" color="var(--sops-app-nav-text-color)" />
          </div>
        )
      },
      {
        id: 'APP_MSP_NAV_CREATE',
        url: null,
        name: 'create',
        location: '',
        icon: (
          <div className="fx center">
            <SVGIcon name="Add" color="var(--sops-app-nav-text-color)" />
          </div>
        )
      },
      {
        id: 'APP_MSP_NAV-SETTINGS',
        url: null,
        name: 'settings',
        access: 'settings',
        label: getTranslatedText(intl, 'app.nav.settings'),
        location: '',
        icon: (
          <div className="fx center">
            <SVGIcon
              name="SettingsDark"
              color="var(--sops-app-nav-text-color)"
            />
          </div>
        )
      }
    ];

    const associations =
      this.context?.user?.accountType === 'CLIENT'
        ? this.context?.multiSiteAssociations || []
        : this.context?.user?.associations || [];
    const reference = this.context?.user?.role?.roleFeatureList || [];

    const hasTicketView = isAuthorised(reference, 'tickets.view');
    const hasProjectView = isAuthorised(reference, 'project.view');

    const workspaceAuthoriseKey = hasTicketView
      ? 'ticket'
      : hasProjectView
      ? 'project'
      : null;

    const workspaceUrl =
      workspaceAuthoriseKey === 'ticket'
        ? '/ticket/1/ticket-list'
        : workspaceAuthoriseKey === 'project'
        ? '/project/1/project-list'
        : null;

    const requestorModules = [
      {
        id: 'CLIENTHOMEKB',
        url: '/client-home',
        name: 'CLIENTHOMEKB',
        label: 'Home',
        icon: (
          <div className="fx center">
            <SVGIcon name="HomePlain" color="var(--sops-app-nav-text-color)" />
          </div>
        ),
        planCheck: KbClientNavCheck
      },
      {
        id: 'CLIENT_TICKETS',
        url: workspaceUrl,
        name: workspaceAuthoriseKey,
        label: workspaceAuthoriseKey === 'ticket' ? 'Tickets' : 'Projects',
        icon: (
          <div className="fx center">
            <SVGIcon
              name="TicketOutline"
              color="var(--sops-app-nav-text-color)"
            />
          </div>
        ),
        tabData: {
          id: 'workspace',
          content: '',
          module: 'WORKSPACE',
          tabId: 'workspace',
          state: {},
          data: {
            isClientPortal: true,
            type: 'TICKETWORKSPACE'
          },
          url: workspaceUrl
        },
        ldFlag: 'psaOnlyPlan',
        planCheck: KbClientNavCheck && workspaceAuthoriseKey
      },
      {
        id: 'CLIENT_TICKETS_ALT',
        url: workspaceUrl,
        name: workspaceAuthoriseKey,
        label: getTranslatedText(intl, 'app.nav.home'),
        icon: (
          <div className="fx center">
            <SVGIcon name="HomePlain" color="var(--sops-app-nav-text-color)" />
          </div>
        ),
        tabData: {
          id: 'workspace',
          content: '',
          module: 'WORKSPACE',
          tabId: 'workspace',
          state: {},
          data: {
            isClientPortal: true
          },
          url: workspaceUrl
        },
        ldFlag: 'psaOnlyPlan',
        planCheck: !KbClientNavCheck && workspaceAuthoriseKey
      },
      {
        id: 'CLIENT_COMPANY',
        url:
          associations.length < 2 &&
          `/client/${associations?.[0]?.client?.accountId}/detail`,
        name: 'company',
        label: getTranslatedText(intl, 'app.nav.company'),
        access: 'client',
        location: '',
        associations: associations,
        icon: (
          <div className="fx center">
            <SVGIcon name="ClientLogo" color="var(--sops-app-nav-text-color)" />
          </div>
        )
      },
      {
        id: 'CLIENT_NEW_TICKET',
        url: null,
        name: 'ticket',
        label: getTranslatedText(intl, 'common.create'),
        access: 'tickets',
        permission: 'add',
        location: '',
        icon: (
          <div className="fx center">
            <SVGIcon name="Add" color="var(--sops-app-nav-text-color)" />
          </div>
        ),
        tabData: {
          id: 'new-tab',
          content: '',
          module: 'NEW',
          tabId: 'new-tab',
          state: {},
          data: {},
          url: '/ticket/aWqgT35s/new'
        },
        ldFlag: 'psaOnlyPlan'
      },
      {
        id: 'CLIENT_SETTINGS',
        url: '/profile/detail/edit',
        name: 'settings',
        label: getTranslatedText(intl, 'app.nav.settings'),
        location: '',
        icon: (
          <div className="fx center">
            <SVGIcon
              name="SettingsDark"
              color="var(--sops-app-nav-text-color)"
            />
          </div>
        )
      }
    ].filter((el) => el?.planCheck === undefined || el?.planCheck);

    if (this.props?.flags?.assetClientPortal) {
      requestorModules.splice(requestorModules?.length - 1, 0, {
        id: 'CLIENT_ASSET',
        url: `/client/rmm/asset-view/4001`,
        name: 'asset',
        label: getTranslatedText(intl, 'ticket.details.insights.assets'),
        icon: <SVGIcon name="AssetMenu" color="#fff" size="lg" />,
        permission: 'view',
        access: 'asset'
      });
    }

    if (this.props?.flags?.shareItDocsToClients) {
      requestorModules.splice(requestorModules?.length - 1, 0, {
        id: 'CLIENT_ITDOCS',
        url: `/client/rmm/itdoc/${CLIENT_PORTAL_IT_DOC_DEFAULT_ENTITY_NAME}&&1001`,
        name: 'document',
        label: getTranslatedText(intl, 'common.documents'),
        icon: (
          <SVGIcon
            name="ItDocumentationIcon"
            color="var(--sops-app-nav-text-color)"
            size="lg"
          />
        ),
        access: 'itDocumentation'
      });
    }

    const renderIcon = (item, appContext) => {
      if (item?.customLogo && appContext?.user?.logoFileName) {
        const module = ALL_MODULES.mspAvatar;
        const details = {
          fileName: appContext.user.logoFileName
        };
        const logoUrl = appContext.user.logoFileName
          ? getDownloadURL({ module, details })
          : false;
        return (
          <Logo className="fx jctr mt-10 mb-10">
            <img
              src={
                this.state.appLogo ||
                logoUrl ||
                `${envConfig.imageRoot}svg/superopsLight.svg`
              }
              alt="Company"
            />
          </Logo>
        );
      }
      return item.icon;
    };

    const isMenuEnabled = (modulesMenu) => {
      return modulesMenu.filter((menu) => {
        if (!menu.ldFlag) {
          return true;
        }
        return this.props?.flags[menu.ldFlag];
      });
    };

    const authorisedRequestorModules = isMenuEnabled(
      requestorModules.filter((el) => {
        if (!el.access) return true;
        const reference = this.context?.user?.role?.roleFeatureList || [];
        const isFeatureAuthorised = isAuthorised(
          reference,
          `${el.access}.${el?.permission || 'view'}`
        );
        return isFeatureAuthorised;
      })
    );

    const authorizedTechnicianModules = isMenuEnabled(
      technicianModules.filter((el) => {
        if (el.featureFlag) {
          if (!this.props.flags?.[el.featureFlag]) return false;
        }
        if (!el.access) return true;
        const reference = this.context?.user?.role?.roleFeatureList || [];
        const isFeatureAuthorised = isAuthorised(
          reference,
          `${el.access}.${el?.permission || 'view'}`
        );
        return isFeatureAuthorised;
      })
    );

    const handleAssosiationClick = (item, homeContext) => {
      this.props.history.push(`/client/${item.client.accountId}/detail`);
      this.setState({
        assosiationPopoverActive: false,
        selectedSection: 'company'
      });
      homeContext.updateSelectedModule('company');
    };

    const handleAssosiationFeatureClick = (homeContext) => {
      if (this.context.selectedModule === 'settings') {
        this.context.toggleSettingsOverlay();
      }
      this.setState({
        assosiationPopoverActive: false,
        selectedSection: 'modules'
      });
    };

    const openMenu = () => {
      this.setState({ openMenuItem: true });
    };

    return (
      <AppNavStyle>
        <AppContext.Consumer>
          {(appContext) => {
            const modules =
              appContext?.accountType === 'CLIENT'
                ? authorisedRequestorModules
                : authorizedTechnicianModules;

            const isWorklogAuthorised = isAuthorised(
              appContext?.user?.role?.roleFeatureList || [],
              `tickets.edit`
            );
            const timerAvailableForPlan =
              appContext?.planFeatureList?.['ST_TRACK_ANYWHERE']?.enabled;
            const isMSPProduct =
              appContext?.currentProduct === COMMON_CONSTANTS.MSP;

            return (
              <HomeContext.Consumer>
                {(homeContext) => (
                  <>
                    {renderIcon(
                      {
                        id: 156,
                        url: '',
                        name: 'logo',
                        location: '',
                        icon: (
                          <Logo className="fx jctr mt-10 mb-10">
                            <img
                              src={`${envConfig.imageRoot}svg/superopsLight.svg`}
                              alt=""
                            />
                          </Logo>
                        ),
                        customLogo: true
                      },
                      appContext
                    )}
                    {modules.map((item) => {
                      const key = item.id || item.name;
                      if (!key) return null;

                      return (
                        <React.Fragment key={key}>
                          {item.name === 'company' &&
                          item.associations &&
                          item.associations.length > 1 ? (
                            <Tippy
                              content={
                                this.state.assosiationPopoverActive ? (
                                  <AssosiationPopover>
                                    {item.associations.map((el) => (
                                      <p
                                        key={el.client?.accountId}
                                        className="assosiation-item"
                                        onClick={() => {
                                          handleAssosiationClick(
                                            el,
                                            homeContext
                                          );
                                        }}
                                      >
                                        {el.client.name}
                                      </p>
                                    ))}
                                  </AssosiationPopover>
                                ) : null
                              }
                              placement="right"
                              arrow={false}
                              interactive
                              trigger="mouseenter"
                              theme="light"
                              allowHTML
                              appendTo={document.body}
                              onShow={() => {
                                this.setState({
                                  assosiationPopoverActive: true
                                });
                              }}
                              onHide={() => {
                                this.setState({
                                  assosiationPopoverActive: false
                                });
                              }}
                              offset={[0, 5]}
                              maxWidth={500}
                            >
                              <div className="company-multiple">
                                <Section
                                  id={`${item.name}SideNavbar`}
                                  selected={
                                    item.name === homeContext.selectedModule
                                  }
                                >
                                  <div
                                    id={item.id}
                                    className="ptr appIcon flex flex-center full-width"
                                  >
                                    <SectionHolder className="full-width">
                                      <div>{renderIcon(item, appContext)}</div>
                                    </SectionHolder>
                                  </div>
                                </Section>
                                <div className="more-icon">
                                  <SVGIcon
                                    name="Menu"
                                    color="var(--sops-app-nav-text-color)"
                                  />
                                </div>
                              </div>
                            </Tippy>
                          ) : item.name === 'modules' ||
                            (item.name === 'create' &&
                              appContext?.accountType !== 'CLIENT') ? (
                            <Tippy
                              content={
                                this.state.assosiationPopoverActive && (
                                  <Wrapper>
                                    <MenuPage
                                      menuName={item.name}
                                      handleClose={
                                        handleAssosiationFeatureClick
                                      }
                                    />
                                  </Wrapper>
                                )
                              }
                              delay={100}
                              placement="left"
                              arrow={false}
                              interactive
                              trigger="mouseenter"
                              theme="light"
                              allowHTML
                              appendTo={document.body}
                              onShow={() => {
                                this.setState({
                                  assosiationPopoverActive: true
                                });
                              }}
                              onHide={() => {
                                this.setState({
                                  assosiationPopoverActive: false
                                });
                              }}
                              offset={[0, 5]}
                              maxWidth={500}
                              minWidth={300}
                              className="app-menu-tippy"
                            >
                              <Section
                                id={`${item.name}SideNavbar`}
                                selected={
                                  item.name === homeContext.selectedModule
                                }
                              >
                                <div
                                  id={item.id}
                                  className={`${
                                    item.customLogo ? '' : 'ptr'
                                  } appIcon flex flex-center full-width`}
                                  url={item.url}
                                >
                                  <Tooltip
                                    title={dompurifier(item.label)}
                                    position="right"
                                    interactive
                                    delay={200}
                                    trigger="mouseenter click"
                                    animation="shift"
                                    animateFill={false}
                                    className="full-width"
                                    open={this.state.openMenuItem}
                                  >
                                    <SectionHolder
                                      className="full-width"
                                      onClick={openMenu}
                                    >
                                      <div>{renderIcon(item, appContext)}</div>
                                    </SectionHolder>
                                  </Tooltip>
                                </div>
                              </Section>
                            </Tippy>
                          ) : item.name === 'updates' ? (
                            appContext?.planFeatureList?.[
                              'IN_APP_NOTIFICATIONS'
                            ]?.enabled && (
                              <NavItemWithTippy
                                item={item}
                                renderIcon={renderIcon}
                                tippyProps={{
                                  trigger: 'click',
                                  onShow: () => {
                                    this.props.resetNotificationsCount();
                                  },
                                  className:
                                    'app-menu-tippy notification-updates-tippy'
                                }}
                                bubbleCount={this.props.notificationsCount}
                              >
                                <Notifications tab={this.props.tabRef} />
                              </NavItemWithTippy>
                            )
                          ) : (
                            <Section
                              id={`${item.name}SideNavbar`}
                              selected={
                                item.name === homeContext.selectedModule
                              }
                            >
                              <div
                                id={item.id}
                                className={`${
                                  item.customLogo ? '' : 'ptr'
                                } appIcon flex flex-center full-width`}
                                url={item.url}
                                onClick={() =>
                                  this.handleClick(
                                    item,
                                    homeContext,
                                    appContext
                                  )
                                }
                              >
                                <Tooltip
                                  title={dompurifier(item.label)}
                                  position="right"
                                  inertia
                                  delay={200}
                                  trigger="mouseenter"
                                  animation="shift"
                                  animateFill={false}
                                  className="full-width"
                                >
                                  <SectionHolder className="full-width">
                                    <div>{renderIcon(item, appContext)}</div>
                                  </SectionHolder>
                                </Tooltip>
                              </div>
                            </Section>
                          )}
                        </React.Fragment>
                      );
                    })}
                    <BottomSection className="full-width">
                      <>
                        <SchedulingNavigationWidget
                          styledComponents={{
                            Section: Section,
                            SectionHolder: SectionHolder
                          }}
                          onClick={() => {
                            if (homeContext.settingsOverlay) {
                              homeContext.closeSettingsOverlay();
                            }
                            this.props.history.push('/scheduling');
                          }}
                        />
                      </>
                      {appContext?.accountType !== 'CLIENT' &&
                        timerAvailableForPlan && (
                          <Section id="timers" className="ptr">
                            <GlobalTimerSection tabRef={this.props.tabRef} />
                          </Section>
                        )}
                      {appContext?.accountType !== 'CLIENT' && (
                        <AccessControl
                          roleToCheck={{
                            roles: ['integrations.view', 'settings.view']
                          }}
                          render={
                            <Section
                              id={
                                isMSPProduct ? 'marketplace' : 'it-marketplace'
                              }
                            >
                              <div
                                id="marketplace-link"
                                className="ptr appIcon flex flex-center full-width"
                                onClick={() => {
                                  if (homeContext.settingsOverlay) {
                                    homeContext.closeSettingsOverlay();
                                  }
                                  this.props.history.push(
                                    '/onboard/integrations'
                                  );
                                }}
                              >
                                <Tooltip
                                  title={getTranslatedText(
                                    intl,
                                    'role.feature.integrations'
                                  )}
                                  position="right"
                                  inertia
                                  delay={200}
                                  trigger="mouseenter"
                                  animation="shift"
                                  animateFill={false}
                                  className="full-width"
                                >
                                  <SectionHolder className="full-width">
                                    <div>
                                      <SVGIcon
                                        name="Integration"
                                        color="var(--sops-app-nav-text-color)"
                                      />
                                    </div>
                                  </SectionHolder>
                                </Tooltip>
                              </div>
                            </Section>
                          }
                        />
                      )}
                      {appContext?.accountType !== 'CLIENT' &&
                        this.props?.flags?.marketplace && (
                          <div
                            id="agent-marketplace-link"
                            className="ptr appIcon flex flex-center full-width"
                            onClick={() => {
                              if (homeContext.settingsOverlay) {
                                homeContext.closeSettingsOverlay();
                              }
                            }}
                          >
                            <Tippy
                              content={
                                <Card>
                                  <div className="flex fcol pb10 pt10">
                                    {marketplaceMenus.map((item) => (
                                      <div
                                        key={item.id}
                                        className="flex-center gap-10 cursor-pointer p10 nav-menu-item"
                                        onClick={() =>
                                          this.props.history.push(item.route)
                                        }
                                      >
                                        <SVGIcon name={item.icon} size="md" />
                                        <TextStyle weight="Medium">
                                          <FormattedMessage
                                            id={item.messageId}
                                          />
                                        </TextStyle>
                                      </div>
                                    ))}
                                  </div>
                                </Card>
                              }
                              delay={100}
                              placement="right"
                              arrow={false}
                              interactive
                              trigger="mouseenter click"
                              theme="light"
                              allowHTML
                              appendTo={document.body}
                              offset={[0, 5]}
                              maxWidth={500}
                            >
                              <SectionHolder className="full-width">
                                <div>
                                  <SVGIcon
                                    name="AgentAILined"
                                    bgFillColor="white"
                                  />
                                </div>
                              </SectionHolder>
                            </Tippy>
                          </div>
                        )}
                      {appContext?.accountType !== 'CLIENT' &&
                        this.props?.flags?.showExplore && (
                          <AccessControl
                            roleToCheck={{
                              roles: ['settings.view']
                            }}
                            productToCheck={COMMON_CONSTANTS.MSP}
                            render={
                              <Section id="explore">
                                <div
                                  id="explore-link"
                                  className="ptr appIcon flex flex-center full-width"
                                  onClick={() => {
                                    window.CommandBar.open();
                                    useActivityTracker({
                                      event: 'LEFT_NAV - Explore Superops.ai'
                                    });
                                  }}
                                >
                                  <Tooltip
                                    title={getTranslatedText(
                                      intl,
                                      'admin.navigation.superops.ai'
                                    )}
                                    position="right"
                                    inertia
                                    delay={200}
                                    trigger="mouseenter"
                                    animation="shift"
                                    animateFill={false}
                                    className="full-width"
                                  >
                                    <SectionHolder className="full-width">
                                      <div>
                                        <SVGIcon
                                          name="Explore"
                                          color="var(--sops-app-nav-text-color)"
                                        />
                                      </div>
                                    </SectionHolder>
                                  </Tooltip>
                                </div>
                              </Section>
                            }
                          />
                        )}
                    </BottomSection>
                    <div className="bottom flex col jctr center user-avatar-left-nav">
                      <UserAppMenuNew
                        {...this.props}
                        tabRef={this.props.tabRef}
                      />
                    </div>
                  </>
                )}
              </HomeContext.Consumer>
            );
          }}
        </AppContext.Consumer>
      </AppNavStyle>
    );
  }
}

export default injectIntl(
  withRouter(
    withLDConsumer()(function AppNav(props) {
      const {
        count: notificationsCount,
        resetNotificationsCount
      } = useInAppNotificationsCount();
      const KbClientNavCheck = useCheckFeatureGating('KNOWLEDGE_BASE')?.enabled;
      return (
        <AppNavigation
          {...props}
          notificationsCount={notificationsCount}
          resetNotificationsCount={resetNotificationsCount}
          KbClientNavCheck={KbClientNavCheck}
        />
      );
    })
  )
);
